import styled from 'styled-components';

const StyledPlaceholder = styled.div`
  width: 100%;
  height: 40px;
  border-radius: 48px;
`;

export const InputPlaceholder = () => {
  return (
    <div className="placeholder-glow w-100">
      <StyledPlaceholder className="placeholder"></StyledPlaceholder>
    </div>
  );
};
